export default [
    {
        path: '/operation',
        meta: {
            title: "Operation",
            icon: "operation.png",
            show: true
        },
        component: () => import(/* webpackChunkName: "operation" */ '../views/admin/page/OperationPage/Index'),
        redirect: { name: 'operation' },
        children: [
            {
                path: 'dashboard',
                name: 'operation',
                meta: {
                    title: "Dashboard",
                    show: true
                },
                component: () => import(/* webpackChunkName: "operation" */ '../views/admin/page/OperationPage/Dashboard'),
            },
            {
                path: 'detail/:id',
                name: 'operationdetail',
                meta: {
                    title: "Operation Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "operation" */ '../views/admin/page/OperationPage/OperationDetail'),
            },
            {
                path: 'detail/:id/:approval/:role',
                name: 'operationdetail.validation',
                meta: {
                    title: "Operation Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "operation" */ '../views/admin/page/OperationPage/OperationDetail'),
            },
            {
                path: 'validation',
                name: 'operation.validation',
                meta: {
                    title: "Operation Validation",
                    show: true
                },
                component: () => import(/* webpackChunkName: "operation" */ '../views/admin/page/OperationPage/ProjectValidation'),
            },
            // {
            //     path: 'spk/:id/:approval/:role',
            //     name: 'hris.spk.approval',
            //     meta: {
            //         title: "SPK Validation",
            //         show: true
            //     },
            //     props: true,
            //     component: () => import(/* webpackChunkName: "hris" */ '../views/admin/page/HrisPage/SPKValidationApproval'),
            // },
        ]
    },
]